module.exports = __webpack_public_path__ + "static/media/loader-boomer.4cf498d6.png";